import React, { useState } from 'react';
import './contact.css'; // Assuming you have a corresponding CSS file

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contactNo: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    const formattedMessage = `📝 *Contact Form Submission* 📝\n\n*Name:* ${formData.name}\n*Email:* ${formData.email}\n*Contact No:* ${formData.contactNo}\n*Message:* ${formData.message}`;
    window.location.href = `https://api.whatsapp.com/send?phone= +923469657528&text=${encodeURIComponent(formattedMessage)}`;
  };

  return (
    <div className="background">
      <div className="container-0000">
        <div className="screen">
          <div className="screen-header">
            <div className="screen-header-left">
              <div className="screen-header-button close"></div>
              <div className="screen-header-button maximize"></div>
              <div className="screen-header-button minimize"></div>
            </div>
            <div className="screen-header-right">
              <div className="screen-header-ellipsis"></div>
              <div className="screen-header-ellipsis"></div>
              <div className="screen-header-ellipsis"></div>
            </div>
          </div>
          <div className="screen-body">
            <div className="screen-body-item left">
              <div className="app-title">
                <span>Contact</span>
                <span>Me</span>
              </div>
              <div className="app-contact">CONTACT INFO : +92 3469657528</div>
            </div>
            <div className="screen-body-item">
              <div className="app-form">
                <div className="app-form-group">
                  <input className="app-form-control" placeholder="NAME" name="name" onChange={handleChange} />
                </div>
                <div className="app-form-group">
                  <input className="app-form-control" placeholder="EMAIL" name="email" onChange={handleChange} />
                </div>
                <div className="app-form-group">
                  <input className="app-form-control" placeholder="CONTACT NO" name="contactNo" onChange={handleChange} />
                </div>
                <div className="app-form-group message">
                  <input className="app-form-control" placeholder="MESSAGE" name="message" onChange={handleChange} />
                </div>
                <div className="app-form-group buttons">
                  <button className="app-form-button">CANCEL</button>
                  <button className="app-form-button" onClick={handleSubmit}>SEND</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;